export default __webpack_public_path__ + "static/media/tulufali_logo.225a3858.png";